import { render } from "./RolesPermissionModal.vue?vue&type=template&id=1e993889&scoped=true"
import script from "./RolesPermissionModal.vue?vue&type=script&lang=js"
export * from "./RolesPermissionModal.vue?vue&type=script&lang=js"

import "./RolesPermissionModal.vue?vue&type=style&index=0&id=1e993889&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e993889"]])

export default __exports__